import { render, staticRenderFns } from "./Comprometimento.vue?vue&type=template&id=1fd0905b&"
import script from "./Comprometimento.vue?vue&type=script&lang=js&"
export * from "./Comprometimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports